import { i as l } from "../../isBot-DfEzHKzJ.js";
import { u as r } from "../../jsxRuntime.module-Bzuv3cXw.js";
import { u as p, a as m } from "../../useLoadMore-A4IkMv_0.js";
import { p as u } from "../../pick-DReBictn.js";
import { h as d, i as f, I as S } from "../../InfiniteScrollWithObserver-CnR-vqQP.js";
import { Fragment as h } from "preact";
import { S as O, b as W, c as A, d as B } from "../../useActions-Cd7V2qfb.js";
function M({ pageSize: e }) {
  const { loadMore: o } = p(e);
  return /* @__PURE__ */ r("button", { onClick: o, children: "More results" });
}
function b({ children: e, loadMoreComponent: o, pageSize: t }) {
  const { loading: n, query: s, response: i } = m((c) => u(c, "loading", "query", "response")), a = !n && d(s, i);
  return /* @__PURE__ */ r(h, { children: [
    e,
    a && (o ? /* @__PURE__ */ r(o, { pageSize: t }) : /* @__PURE__ */ r(M, { pageSize: t }))
  ] });
}
const q = !l() && f() ? S : b;
export {
  q as InfiniteScroll,
  b as InfiniteScrollWithLink,
  O as StoreContext,
  W as createExtendableStore,
  A as createStore,
  B as defaultState
};
